import type { TaskTypeViewRegion } from '@erp/shared-types';

export const SIDE_PANEL_NOTES_TAB = 'notes';
export const SIDE_PANEL_TIMELINE_TAB = 'timeline';

/** Region ids are author-chosen and may collide with the built-in tabs. */
export function regionTabValue(regionId: string): string {
  return `region:${regionId}`;
}

/**
 * Tab order for the right rail: the type's Side sections in spec order, then
 * Task Activity and Task Notes, which are always last. Task Activity is the
 * tab that opens with the task.
 */
export function sidePanelTabs(
  asideRegions: readonly TaskTypeViewRegion[],
  labels: { notes: string; timeline: string; untitled: (n: number) => string },
): Array<{ value: string; label: string }> {
  const regionTabs = asideRegions.map((region, index) => ({
    value: regionTabValue(region.id),
    label: region.title?.trim() || labels.untitled(index + 1),
  }));
  return [
    ...regionTabs,
    { value: SIDE_PANEL_TIMELINE_TAB, label: labels.timeline },
    { value: SIDE_PANEL_NOTES_TAB, label: labels.notes },
  ];
}
